<chart [type]="'doughnut'" [data]="doughnutData" [options]="doughnutOptions"></chart>